import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "overrides", "className", "width", "height", "autoHide", "autoHeight", "autoHeightMin", "autoHeightMax"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import { getOverrides } from 'hoi-poi-ui';
const ScrollBar = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      overrides: overridesProp,
      className: classNameProp,
      width,
      height,
      autoHide = true,
      autoHeight,
      autoHeightMin,
      autoHeightMax
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  // Overrides
  const override = getOverrides(overridesProp, ScrollBar.overrides);

  // Classes
  const rootClassName = classnames(classNameProp);
  let style = {};
  if (width) style.width = width;
  if (height) style.height = height;
  const rootProps = _objectSpread(_objectSpread({
    style,
    autoHide,
    autoHeight,
    autoHeightMin,
    autoHeightMax,
    ref
  }, props), override.root);
  return /*#__PURE__*/React.createElement(Scrollbars, _extends({
    className: rootClassName
  }, rootProps), children);
});
ScrollBar.overrides = ['root'];
process.env.NODE_ENV !== "production" ? ScrollBar.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  autoHide: PropTypes.bool,
  autoHeight: PropTypes.bool,
  autoHeightMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  autoHeightMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : void 0;
export default /*#__PURE__*/memo(ScrollBar);